import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SolarOrbit from "./SolarOrbit";
import { testimonials } from "../data/siteData";
import "./Testimonials.css";

export default function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduceMotion) return undefined;

    const id = setInterval(() => {
      setIndex((i) => (i + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(id);
  }, []);

  const current = testimonials[index];

  return (
    <section className="testimonials section">
      <div className="container testimonials__inner">
        <SolarOrbit size="lg" className="testimonials__orbit" />
        <div className="testimonials__content">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={current.id}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            >
              <p className="testimonials__quote">&ldquo;{current.quote}&rdquo;</p>
              <footer>
                <span>{current.name}</span>
                <span className="testimonials__location">{current.location}</span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>

          <div className="testimonials__dots">
            {testimonials.map((t, i) => (
              <button
                key={t.id}
                type="button"
                aria-label={`Show testimonial ${i + 1}`}
                className={`testimonials__dot ${i === index ? "testimonials__dot--active" : ""}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
